import { createApiConstants, createConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'performanceHistory';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const INITIALIZE = createApiNamespacedConstants('INITIALIZE');
export const GET_METRICS_HISTORY = createApiNamespacedConstants('GET_METRICS_HISTORY');
export const GET_JOB_DATA = createApiNamespacedConstants('GET_JOB_DATA');
export const GET_SELECTED_BASELINE_JOB_DATA = createApiNamespacedConstants('GET_SELECTED_BASELINE_JOB_DATA');
export const UPDATE = createConstants(NAMESPACE, 'update')(
  'SELECTED_TEST_PAGE_INFO',
  'SELECTED_METRICS',
  'SELECTED_BASELINE_CHART_DATA_POINT',
  'PERF_TYPE',
);

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
